import { BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import { COMPANY_OVERVIEW_NAMES } from 'components/BusinessToolForm/Sections/Overview/CompanyOverview/utils/form';
import { FUNDING_NEEDS_NAMES } from 'components/BusinessToolForm/Sections/Overview/FundingNeedsOverview/utils/form';
import { COMPANY_PROJECT_NAMES } from 'components/BusinessToolForm/Sections/Overview/ProjectOverview/utils/form';

import { ul } from '../helpers';

const OVERVIEW_COMPANY_INSTRUCTIONS = {
  [COMPANY_OVERVIEW_NAMES.LIFE_CYCLE_STAGES]: {
    name: 'Etapa del ciclo de vida',

    instruction:
      'Indique la etapa actual del ciclo de vida de la empresa. Especifique si se encuentra en fase de creación, crecimiento, madurez o transformación, reflejando de forma clara su situación actual.',

    exampleOne: 'Crecimiento',
    exampleTwo: 'Madurez',
  },
};

const OVERVIEW_PROJECT_INSTRUCTIONS = {
  [COMPANY_PROJECT_NAMES.STATUS]: {
    name: 'Estado del proyecto',

    instruction: `Seleccione la etapa que mejor describa la situación actual del proyecto:
      ${ul([
        'Validación de la idea: Evaluación de la viabilidad, el potencial comercial y la oportunidad de mercado de la idea de negocio.',
        'Investigación y desarrollo (I+D): Desarrollo de prototipos, pruebas y estudios técnicos o de mercado para validar la solución.',
        'Evaluación y selección: Análisis de distintas estrategias o modelos de negocio para identificar la alternativa más adecuada.',
        'Financiación: Obtención de los recursos financieros necesarios para poner en marcha o ampliar el proyecto.',
        'Implementación: Ejecución del plan de negocio y lanzamiento del producto o servicio al mercado.',
        'Operación y gestión: Gestión de las operaciones diarias, optimización de procesos y desarrollo sostenible de la empresa.',
      ])}`,

    exampleOne: 'Evaluación y selección',
    exampleTwo: 'Implementación',
  },
};

const FUNDING_NEEDS_INSTRUCTIONS = {
  [FUNDING_NEEDS_NAMES.FUNDING_DIRECTIONS]: {
    name: 'Destino de la financiación',

    instruction:
      'Especifique cómo se distribuirán los fondos entre las principales áreas de inversión, como investigación y desarrollo (I+D), marketing, capital de trabajo, construcción, adquisición de equipos u otras necesidades estratégicas.',

    exampleOne: '',
    exampleTwo: '',
  },
};

export const OVERVIEW_INSTRUCTIONS = {
  [BUSINESS_TOOL_SUB_SECTIONS.OVERVIEW.COMPANY]: OVERVIEW_COMPANY_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.OVERVIEW.PROJECT]: OVERVIEW_PROJECT_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.OVERVIEW.FUNDING_NEEDS]: FUNDING_NEEDS_INSTRUCTIONS,
};
